import React from 'react';
import { IPrice } from '../../../../../shared/i18n/price/IPrice';
import { Price } from '../../../../../shared/i18n/price/Price';
import { getFormattedPrice } from '../../../../../shared/i18n/price/utils/getFormattedPrice';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';
import { StyledGrandTotal } from './GrandTotal';
import styled from '@emotion/styled';

const StyledPrice = styled.span`
	margin-left: auto;
`;

interface IRefundTotalProps {
	priceDifference: IPrice;
}

export const RefundTotal = ({ priceDifference }: IRefundTotalProps) => {
	const { t } = useTranslation();

	const refundAmount = new Price({
		currencyCode: priceDifference.currencyCode,
		centAmount: Math.abs(priceDifference.centAmount),
	});

	return (
		<StyledGrandTotal>
			{t('web_booking_summary_refund_due')}
			<StyledPrice>{getFormattedPrice(refundAmount)}</StyledPrice>
		</StyledGrandTotal>
	);
};
